import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom"
import { httpRequest } from 'utils/httpRequest';
import { Pagination } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';

// import { Button } from "reactstrap";

const ViewSubChapter = () => {

    const [subSubChapterData, setSubSubChapterData] = useState([])
    const [isSubChapters, setIsSubChapters] = useState(false)
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    const { loading, startLoading, stopLoading } = useLoader()

    const { id: chapterId } = useParams()



    // Sample data - you can replace this with your dynamic data
    const [data, setData] = useState([
        { id: 1, name: 'Chris Gayle', email: 'john@example.com', },
        { id: 2, name: 'Wevill Hinds', email: 'jane@example.com', },
        { id: 3, name: 'SN Chanderpaul', email: 'mike@example.com', },
        { id: 4, name: 'Ramnaresh Sarwan', email: 'sarah@example.com', },
        { id: 5, name: 'Brian Lara', email: 'tom@example.com', },
        { id: 6, name: 'Richardo Powell', email: 'lisa@example.com', },
        { id: 7, name: 'Marvya Dillion', email: 'mark@example.com', },
    ]);

    const navigate = useNavigate();

    //pagination
    const handlePageChange = (page) => {
        setActivePage(page);
        getSubSubChapters(page, limit);
    };



    //pagination



    const handleDelete = async (id) => {
        try {

            const response = await httpRequest(
                `chapter/delete/${id}`,
                "DELETE",
                {},
                {},
                true,
                false
            );
            if (response?.code === 200) {
                console.log("res", response)
                const newTotal = total - 1;
                const maxPages = Math.ceil(newTotal / limit);
                const newPage = activePage > maxPages ? maxPages : activePage;

                setTotal(newTotal)
                setActivePage(newPage)
                getSubSubChapters(newPage, limit)

            }
        } catch (error) {
            console.log("delete error:", error);

        }
    };

    const handleEdit = (id) => {
        navigate(`/admin/edit-chapter/${id}`)
    };



    // const handleNavigationOnAddChapter=()=>{
    //     navigate("/admin/add-chapter");
    // }


    const handleNavigationOnAddSubChapter = (id) => {
        navigate(`/admin/add-sub-chapter/${id}`);
    }

    const handleNavigationOnView = async (id) => {
        // navigate(`/admin/view-chapter/${id}`);
        try {
            const response = await httpRequest(
                `chapter/get/${id}`,
                "GET",
                {},
                {},
                true,
                false
            );

            const hasSubChapters =
                "subChapters" in response.data &&
                Array.isArray(response.data.subChapters) &&
                response.data.subChapters.length > 0;

            if (hasSubChapters) {
                navigate(`/admin/view-sub-chapter/${id}`);
            } else {
                navigate(`/admin/chapter-details/${id}`);
            }
        } catch (error) {
            console.log("Navigation error:", error);
        }
    }



    const getSubSubChapters = async (page = 1, pageLimit = 10) => {
        startLoading()
        try {

            const response = await httpRequest(
                `chapter/get/${chapterId}`,
                "GET",
                {},
                {
                    page: page,
                    limit: pageLimit
                },
                true,
                false
            );
            if (response?.code === 200) {

              
                if (
                    'subChapters' in response.data &&
                    Array.isArray(response?.data?.subChapters) &&
                    response.data.subChapters.length > 0
                ) {
                    setSubSubChapterData(response?.data?.subChapters)
                    setTotal(response?.total);
                    setActivePage(response?.page);
                    setLimit(response?.limit);
                    setIsSubChapters(true);

                } else {
                    // navigate(`/admin/chapter-details/${chapterId}`, { replace: true })
                    setSubSubChapterData([]);
                    setTotal(0); // or response?.total if backend sends it
                    setActivePage(1);
                    setIsSubChapters(false);
                    navigate(-1)
                }



                
                setSubSubChapterData(response?.data?.subChapters)


            }

        } catch (error) {
            console.log(error);
        } finally {
            stopLoading()
        }
    }


    useEffect(() => {
        if (chapterId) {
            getSubSubChapters(activePage, limit)
        }
    }, [chapterId])




    return (
        <>
            {loading ? <CircleLoader /> : (<div className="container-fluid py-4 mt-5">

                <div className="row">
                    <div className="col">
                        <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0 d-flex justify-content-end">
                                <h3 className="mb-0 mr-auto">Sub Chapters</h3>
                                {/* <Button color="primary" size="sm" onClick={handleNavigationOnAddChapter}>
                                    Add Chapter
                                </Button> */}
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col">Sub Sub Chapter Name</th>

                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {subSubChapterData && subSubChapterData.length > 0 && subSubChapterData.map((item, index) => (
                                            <tr key={item._id}>

                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                    {(activePage - 1) * limit + index + 1}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {item?.title}
                                                    </span>
                                                </td>


                                                <td>
                                                    <button
                                                        className='btn btn-sm'
                                                        onClick={() => handleNavigationOnView(item._id)}
                                                        title="view"
                                                    >
                                                        <i class="fa-solid fa-eye text-primary"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-sm"
                                                        onClick={() => handleEdit(item._id)}
                                                        title="Edit"
                                                    >
                                                        <i className="fas fa-edit text-primary me-2" title="Edit"></i>

                                                    </button>
                                                    <button
                                                        className='btn btn-sm'
                                                        onClick={() => handleNavigationOnAddSubChapter(item?._id)}
                                                        title='Add'
                                                    >
                                                        <i class="fa-solid fa-plus text-primary"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item._id)}
                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-trash"></i>

                                                    </button>

                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            <div className="card-footer py-4">
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        size="sm"
                                        total={total}
                                        limit={limit}
                                        activePage={activePage}
                                        onChangePage={handlePageChange}
                                        maxButtons={5}
                                        prev
                                        next
                                        last
                                        first
                                        ellipsis
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            )}

        </>
    );
};

export default ViewSubChapter;